import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/admin/Sidebar";
import PantallaCarga from "../components/admin/PantallaCarga";
import { useEffect, useState } from "react";
import { getMeAdmin } from "../services/admin/accesos_admin";

function AdminLayout() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setOpen(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("usuario_token");

    if (!token) {
      navigate("/administrator_jx677/login");
      return;
    }

    let mounted = true;

    (async () => {
      try {
        const me = await getMeAdmin();

        if (!mounted) return;

        localStorage.setItem("permisos", JSON.stringify(me.permisos || []));
        localStorage.setItem("usuario_id", String(me.usuario_id || ""));
      } catch (e) {

        localStorage.removeItem("usuario_token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("usuario_id");
        localStorage.removeItem("permisos");

        navigate("/administrator_jx677/login");
        return;
      } finally {
        if (mounted) setBooting(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  // Mientras se piden el usuario y los permisos. Antes devolvia null y
  // quedaba la pantalla en blanco, sin senal de que algo estaba pasando.
  if (booting) {
    return <PantallaCarga mensaje="Loading panel..." tema="claro" fijo />;
  }

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        background: "linear-gradient(135deg, #F4F7FB 0%, #EAF0F8 100%)",
      }}
    >

      <div
        style={{
          width: open ? (collapsed ? "70px" : "260px") : "0px",
          height: "100vh",
          position: screenWidth < 768 ? "fixed" : "relative",
          overflow: "hidden",
          zIndex: 3001,
          transition: "width 0.25s ease",
        }}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      <div
        style={{
          flex: 1,
          height: "100vh",
          overflow: "hidden",
          padding: "16px 18px",
          display: "flex",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            // Sin marco ni ancho maximo: el contenido usa toda la pantalla.
            // Antes era una tarjeta translucida con blur, borde y sombra que
            // recortaba el ancho a 1550px y comia espacio con su padding.
            width: "100%",

            // Alto definido (llena el hueco disponible) para que las paginas
            // puedan usar height: 100% y scrollear solo por dentro.
            height: "100%",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",

            // auto y no hidden: una pagina que no maneje su alto scrollea
            // aca dentro en vez de quedar recortada.
            overflow: "auto",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
